import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mt-3 checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = {
  class: "form-check-label",
  for: "scaleItem"
}
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "f-w-700" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "f-w-700" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "f-w-700" }
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["placeholder"]

import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import { useI18n } from 'vue-i18n'
import { productScaleLanguage } from '@/core/locales/products-language'


export default /*@__PURE__*/_defineComponent({
  __name: 'productScale',
  setup(__props) {

const { t } = useI18n({
  messages: productScaleLanguage
})

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const scaleData = productGroup.scale
        compState.scaleItem = scaleData.scaleItem
        compState.weightDecimalPlaces = scaleData.weightDecimalPlaces
        compState.scaleMultiplier = scaleData.scaleMultiplier
        compState.tare = scaleData.tare
    }
})

const compState = reactive({
    scaleItem: false,
    weightDecimalPlaces: 0,
    scaleMultiplier: 0,
    tare: 0
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const scaleData = productGroup.scale
        compState.scaleItem = scaleData.scaleItem
        compState.weightDecimalPlaces = scaleData.weightDecimalPlaces
        compState.scaleMultiplier = scaleData.scaleMultiplier
        compState.tare = scaleData.tare
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        scale: {
            scaleItem: newVal.scaleItem,
            weightDecimalPlaces: newVal.weightDecimalPlaces,
            scaleMultiplier: newVal.scaleMultiplier,
            tare: newVal.tare
        }
    })

}, { deep: true });

const weightDecimalPlacesDecrement = () => {
    compState.weightDecimalPlaces++
}

const weightDecimalPlacesIncrement = () => {
    if (compState.weightDecimalPlaces > 0) {
        compState.weightDecimalPlaces--
    }
}
const scaleMultiplierDecrement = () => {
    compState.scaleMultiplier++
}

const scaleMultiplierIncrement = () => {
    if (compState.scaleMultiplier > 0) {
        compState.scaleMultiplier--
    }
}
const tareDecrement = () => {
    compState.tare++
}

const tareIncrement = () => {
    if (compState.tare > 0) {
        compState.tare--
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            id: "scaleItem",
            type: "checkbox",
            value: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.scaleItem) = $event))
          }, null, 512), [
            [_vModelCheckbox, compState.scaleItem]
          ]),
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('Scale Item')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", null, [
        _createElementVNode("h6", _hoisted_7, _toDisplayString(_unref(t)('Stock Low Watermark')), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: _unref(t)('Threshold'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.weightDecimalPlaces) = $event))
        }, null, 8, _hoisted_9), [
          [_vModelText, compState.weightDecimalPlaces]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: weightDecimalPlacesIncrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: weightDecimalPlacesDecrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", null, [
        _createElementVNode("h6", _hoisted_11, _toDisplayString(_unref(t)('Stock High Watermark')), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: _unref(t)('Threshold'),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.scaleMultiplier) = $event))
        }, null, 8, _hoisted_13), [
          [_vModelText, compState.scaleMultiplier]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: scaleMultiplierIncrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: scaleMultiplierDecrement
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", null, [
        _createElementVNode("h6", _hoisted_15, _toDisplayString(_unref(t)('Sale to Stock Unit Ratio')), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: _unref(t)('Threshold'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.tare) = $event))
        }, null, 8, _hoisted_17), [
          [_vModelText, compState.tare]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-end-0",
          type: "button",
          onClick: tareIncrement
        }, "-"),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary rounded-start-0",
          type: "button",
          onClick: tareDecrement
        }, "+")
      ])
    ])
  ]))
}
}

})